import i18next, {
  i18n,
  TFunctionKeys,
  TFunction,
  TOptions,
  InitOptions,
} from 'i18next';
import {initReactI18next} from 'react-i18next';
import {IS_CLIENT, REGION} from './constant';
import LOCALE_ID from './locale/id';
import LOCALE_KO from './locale/ko';
import LOCALE_TH from './locale/th';
import LOCALE_ZHT from './locale/zh-Hant';
import {actions as commonActions} from './state/action';
import {getClientStore, IReduxState} from './store';
import {PStore} from './type';
import {assert} from './util/assert';
import {typedSelect} from './util/saga';

const instanceMap: {[key: string]: i18n} = {};
export function getI18nextInstance(lang: string, store: PStore) {
  if (instanceMap[lang]) {
    if (!store.getState().common.tFunction) {
      store.dispatch(
        commonActions.setValue('tFunction', makeTFunction(instanceMap[lang]))
      );
    }
    return instanceMap[lang];
  }

  const resources: InitOptions['resources'] = {};
  switch (REGION) {
    case 'kor':
      resources.ko = {
        translation: LOCALE_KO,
      };
      break;
    case 'twn':
      resources.zht = {
        translation: LOCALE_ZHT,
      };
      break;
    case 'tha':
      resources.th = {
        translation: LOCALE_TH,
      };
      break;
    case 'idn':
      resources.id = {
        translation: LOCALE_ID,
      };
      break;
  }

  const param = {
    lng: lang,
    fallbackLng: lang,
    debug: false,
    resources,
    interpolation: {
      escapeValue: false,
    },
  };

  if (IS_CLIENT) {
    i18next.use(initReactI18next).init(param);
    instanceMap[lang] = i18next;
  } else {
    const inst = i18next.createInstance(param).use(initReactI18next);
    inst.init();
    instanceMap[lang] = inst;
  }

  if (!store.getState().common.tFunction) {
    store.dispatch(
      commonActions.setValue('tFunction', makeTFunction(instanceMap[lang]))
    );
  }

  return instanceMap[lang];
}

const makeTFunction =
  (i18Instance: i18n): TFunction =>
  (key: TFunctionKeys | TFunctionKeys[], options?: TOptions<object> | string) =>
    i18Instance.t(key, options);

export function clientT(key: string, options?: TOptions<object> | string) {
  assert(IS_CLIENT, 'clientT 함수는 클라이언트 사이드에서만 호출해야합니다');
  const t = getClientStore()?.getState().common.tFunction;
  assert(t, 'clientT 함수는 리덕스에 tFunction을 저장한 후에 호출해야합니다');
  return t!(key, options);
}

export function* selectT() {
  return yield* typedSelect((state: IReduxState) => state.common.tFunction!);
}
